import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notifikasi-skeleton',
  templateUrl: './notifikasi-skeleton.component.html',
  styleUrls: ['./notifikasi-skeleton.component.scss'],
})
export class NotifikasiSkeletonComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
